export const ITEM_API_FAIL = "ITEM_API_FAIL";

// ITEMs
export const GET_ITEMS = "GET_ITEMS";
export const GET_ITEMS_FAIL = "GET_ITEMS_FAIL";
export const GET_ITEMS_SUCCESS = "GET_ITEMS_SUCCESS";

// Add ITEM
export const POST_ITEM = "POST_ITEM";
export const POST_ITEM_FAIL = "POST_ITEM_FAIL";
export const POST_ITEM_SUCCESS = "POST_ITEM_SUCCESS";

// Post ITEM on Sale
export const POST_ITEM_SALE = "POST_ITEM_SALE";
export const POST_ITEM_SALE_FAIL = "POST_ITEM_SALE_FAIL";
export const POST_ITEM_SALE_SUCCESS = "POST_ITEM_SALE_SUCCESS";

// Get ITEM
export const GET_ITEM = "GET_ITEM";
export const GET_ITEM_BY_TOKEN = "GET_ITEM_BY_TOKEN";
export const GET_ITEM_FAIL = "GET_ITEM_FAIL";
export const GET_ITEM_SUCCESS = "GET_ITEM_SUCCESS";

// update ITEM
export const PUT_ITEM = "PUT_ITEM";
export const PUT_ITEM_FAIL = "PUT_ITEM_FAIL";
export const PUT_ITEM_SUCCESS = "PUT_ITEM_SUCCESS";

// Delete ITEM
export const DELETE_ITEM = "DELETE_ITEM";
export const DELETE_ITEM_FAIL = "DELETE_ITEM_FAIL";
export const DELETE_ITEM_SUCCESS = "DELETE_ITEM_SUCCESS";

// Get Activities
export const GET_ACTIVITIES = "GET_ACTIVITIES";
export const GET_ACTIVITIES_FAIL = "GET_ACTIVITIES_FAIL";
export const GET_ACTIVITIES_SUCCESS = "GET_ACTIVITIES_SUCCESS";

// Buy ITEM
export const POST_ITEM_BUY = "POST_ITEM_BUY";
export const POST_ITEM_BUY_FAIL = "POST_ITEM_BUY_FAIL";
export const POST_ITEM_BUY_SUCCESS = "POST_ITEM_BUY_SUCCESS";

// Toggle Sale
export const POST_TOGGLE_ITEM_SALE = "POST_TOGGLE_ITEM_SALE";
export const POST_TOGGLE_ITEM_SALE_FAIL = "POST_TOGGLE_ITEM_SALE_FAIL";
export const POST_TOGGLE_ITEM_SALE_SUCCESS = "POST_TOGGLE_ITEM_SALE_SUCCESS";

// Place Bid
export const POST_BID = "POST_BID";
export const POST_BID_FAIL = "POST_BID_FAIL";
export const POST_BID_SUCCESS = "POST_BID_SUCCESS";

// Delete Bid
export const DELETE_BID = "DELETE_BID";
export const DELETE_BID_FAIL = "DELETE_BID_FAIL";
export const DELETE_BID_SUCCESS = "DELETE_BID_SUCCESS";

// Post Bid Action
export const POST_BID_ACTION = "POST_BID_ACTION";
export const POST_BID_ACTION_FAIL = "POST_BID_ACTION_FAIL";
export const POST_BID_ACTION_SUCCESS = "POST_BID_ACTION_SUCCESS";

// Get Bids
export const GET_BIDS = "GET_BIDS";
export const GET_BIDS_FAIL = "GET_BIDS_FAIL";
export const GET_BIDS_SUCCESS = "GET_BIDS_SUCCESS";

//Favourite
export const POST_FAVOURITE = "POST_FAVOURITE";
export const POST_FAVOURITE_FAIL = "POST_FAVOURITE_FAIL";
export const POST_FAVOURITE_SUCCESS = "POST_FAVOURITE_SUCCESS";
//Favourite
export const GET_FAVOURITE = "GET_FAVOURITE";
export const GET_FAVOURITE_FAIL = "GET_FAVOURITE_FAIL";
export const GET_FAVOURITE_SUCCESS = "GET_FAVOURITE_SUCCESS";

// Search Data
export const GET_SEARCH = "GET_SEARCH";
export const GET_SEARCH_FAIL = "GET_SEARCH_FAIL";
export const GET_SEARCH_SUCCESS = "GET_SEARCH_SUCCESS";

//  Abuse
export const REPORT_ABUSE = "REPORT_ABUSE";
export const REPORT_ABUSE_FAIL = "REPORT_ABUSE_FAIL";
export const REPORT_ABUSE_SUCCESS = "REPORT_ABUSE_SUCCESS";

// Upcoming Items
export const UPCOMING_AUCTION = "UPCOMING_AUCTION";
export const UPCOMING_AUCTION_FAIL = "UPCOMING_AUCTION_FAIL";
export const UPCOMING_AUCTION_SUCCESS = "UPCOMING_AUCTION_SUCCESS";

// item by id

export const GET_ITEM_BY_ID = "GET_ITEM_BY_ID";
export const GET_ITEM_BY_ID_FAIL = "GET_ITEM_BY_ID_FAIL";
export const GET_ITEM_BY_ID_SUCCESS = "UPCOMING_AUCTION_SUCCESS";


// item of current owner
export const GET_ITEM_BY_CURRENT_OWNER_ID = "GET_ITEM_BY_CURRENT_OWNER_ID";
export const GET_ITEM_BY_CURRENT_OWNER_ID_FAIL = "GET_ITEM_BY_CURRENT_OWNER_ID_FAIL";
export const GET_ITEM_BY_CURRENT_OWNER_ID_SUCCESS = "GET_ITEM_BY_CURRENT_OWNER_ID_SUCCESS";


// like and view count
export const LIKE_VIEW_COUNT = "LIKE_VIEW_COUNT";
export const LIKE_VIEW_COUNT_FAIL = "LIKE_VIEW_COUNT_FAIL";
export const LIKE_VIEW_COUNT_SUCCESS = "LIKE_VIEW_COUNT_SUCCESS";


// user total nft view 
export const USER_ALL_NFT_COUNT = "USER_ALL_NFT_COUNT";
export const USER_ALL_NFT_COUNT_FAIL = "USER_ALL_NFT_COUNT_FAIL";
export const USER_ALL_NFT_COUNT_SUCCESS = "USER_ALL_NFT_COUNT_SUCCESS";


// nft from collection 

export const NFT_FROM_COLLECTION = "NFT_FROM_COLLECTION";
export const NFT_FROM_COLLECTION_FAIL = "NFT_FROM_COLLECTION_FAIL";
export const NFT_FROM_COLLECTION_SUCCESS = "NFT_FROM_COLLECTION_SUCCESS";
